// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"ChatRoomStatusIcon_statusIcon__1SBRp"};